module.exports = __webpack_public_path__ + "img/fvcom.c5c5cd2a.png";